import script from "./CouponView.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponView.vue?vue&type=script&setup=true&lang=js"

import "./CouponView.vue?vue&type=style&index=0&id=7ba2e62a&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba2e62a"]])

export default __exports__